import { useFetchSystemUser } from "core/api";

/**
 * Hook that retrieves and computes cache TTL (Time-To-Live) values in milliseconds for both extended and normal caching
 * based on the current user server settings.
 *
 * @returns
 * - `extendedTimeToLive`: The extended TTL in milliseconds (default is 5 minutes if not set).
 * - `normalTimeToLive`: The normal TTL in milliseconds (default is 5 minutes if not set).
 */
export function useCacheTimes() {
  const { data: user } = useFetchSystemUser();

  const extendedTimeToLive =
    parseInt(user?.systemConfig?.liveDataCacheExtendedTTL?.value ?? "5") *
    60000;

  const normalTimeToLive =
    parseInt(user?.systemConfig?.liveDataCacheTTL?.value ?? "5") * 60000;

  return { extendedTimeToLive, normalTimeToLive };
}
